import {Component, inject} from '@angular/core';
import {SetClientFormComponent} from "./set-client-form/set-client-form.component";
import {DatevIntegrationService} from "./services/datev-integration.service";
import {SetConfigFormComponent} from "./set-config-form/set-config-form.component";
import {ActivatedRoute, Router} from '@angular/router';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {switchMap, filter, tap, finalize, catchError, throwError, of, take} from 'rxjs';
import {DatevIntegrationRestService} from "./services/datev-integration.rest.service";
import {UserService} from "../../core/user/services/user.service";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";

@Component({
  selector: 'app-datev-integration',
  imports: [
    SetClientFormComponent,
    SetConfigFormComponent,
    MatProgressSpinnerModule,
  ],
  templateUrl: './datev-integration.component.html',
  styleUrl: './datev-integration.component.scss'
})

export class DatevIntegrationComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  protected readonly datevRestService = inject(DatevIntegrationRestService);
  protected readonly datevService = inject(DatevIntegrationService);
  protected readonly userService = inject(UserService);

  constructor() {
    this.datevService.setLoading(true);

    this.userService.selectedIdf$
      .pipe(
        takeUntilDestroyed(),
        filter((idf): idf is string => !!idf),
        tap(idf => sessionStorage.setItem('idf', idf)),
        switchMap(idf => this.datevRestService.datevUser(idf)),
        tap(res => {
          console.log(res)
          this.datevService.setUser(res.return_object.user);
          this.datevService.setActivated(res.return_object.active);
        }),
        tap(() => {
          if (this.datevService.isUser() && this.datevService.isActivated()) {
            this.datevService.setLoading(false);
          }
        }),
        // filter(() => !this.datevService.isUser() && !this.datevService.isActivated()),
        filter(() => !this.datevService.isActivated()),
        switchMap(() => this.getUrlParams()),
        tap(res => {
          if (res?.error_code === null) {
            this.datevService.setUser(true);
            this.datevService.setActivated(true);
          }
        })
      )
      .subscribe({
        next: () => {
          this.router.navigate([], {
            queryParams: {},
            replaceUrl: true
          });
          this.datevService.setLoading(false);
        },
        error: (err: any) => console.error('Error:', err),
        complete: () => this.datevService.setLoading(false)
      });
  }

  private getUrlParams() {
    return this.route.queryParams.pipe(
      take(1),
      switchMap(params => {
        if (params['code'] || params['error']) {
          if (params['error']) {
            console.error('Datev error:', params['error_description']);
            return throwError(() => new Error(params['error_description']));
          }

          const clientId = sessionStorage.getItem('clientId') ?? '';
          const idf = sessionStorage.getItem('idf') ?? '';

          return this.datevRestService.getDatevToken(params['code'], clientId, idf);
        }

        return of(null);
      }),
      catchError(err => {
        console.error('Token fetch error:', err);
        return of(null);
      })
    );
  }
}

